
import React from 'react';

function Franchise() {
  return (
    <div>
      <h1>Franchise Page</h1>
    </div>
  );
}

export default Franchise;
